export const __typename = 'CurrentUser';

export const defaults = {
  currentUser: {
    __typename,
    email: null,
    firstName: null,
    lastName: null,
    position: null,
    language: null
  }
};

const currentUser = {
  resolvers: {
    Query: {
      getCurrentUser: (_, variables, { cache }) => cache.data.data[__typename]
    },
    Mutation: {
      setCurrentUser: (_, variables, { cache }) => {
        const data = {
          currentUser: {
            __typename,
            ...variables
          }
        };
        cache.writeData({ data });
        return null;
      }
    }
  },
  defaults
};

export default currentUser;
